import { useQuery } from '@tanstack/react-query'
import { apiGetAllNews } from './api'
import { GetAllNewsPayload, GetAllNewsResponse } from './type'
import useNewsPaginationStore from '@/stores/news/useNewsPaginationStore'

const MEDIA_NEWS_NEWTYPE_ID = Number(process.env.NEXT_PUBLIC_MEDIA_NEWS_NEWTYPE_ID)

const FIXED_PAYLOAD = {
    keywords: '',
    newsTypeId: MEDIA_NEWS_NEWTYPE_ID,
    isPublic: '',
} as const

export const useGetAllNewsQuery = () => {
    const { currentPage, pageSize } = useNewsPaginationStore()

    const payload: GetAllNewsPayload = {
        ...FIXED_PAYLOAD,
        page: currentPage,
        pageSize,
    }

    return useQuery<GetAllNewsResponse>({
        queryKey: ['news', 'list', { currentPage, pageSize }],
        queryFn: () => apiGetAllNews(payload),
        placeholderData: (previousData) => previousData,
        staleTime: 5 * 60 * 1000,
    })
}

export const useGetNewsByNewTypeIdQuery = ({ payload }: { payload: GetAllNewsPayload }) => {
    return useQuery<GetAllNewsResponse>({
        queryKey: ['news', 'list', payload],
        queryFn: () => apiGetAllNews(payload),
        placeholderData: (previousData) => previousData,
        staleTime: 5 * 60 * 1000,
    })
}